import {
    IonContent, IonInput,
    IonPage,
} from '@ionic/react';
import React, {Component} from 'react';

import './PhoneRegister.css';
import {AuthSendCode, userRealAuth, userRegister} from "./Service";
import {Helmet} from 'react-helmet';
import Script from 'react-load-script';
import cookieUtil from "../../utils/cookieUtil";
import {withRouter} from 'react-router-dom';
import MFooter from "../../components/MFooter";
import {captchaRegAppId, captchaUrl} from "../../utils/common";

class PhoneRegister extends Component {

    constructor(props) {
        super(props);

        this.state = {
            phone: '',
            phoneTip: 0,
            code: '',
            codeTip: null,
            password: '',
            passwordTip: null,
            agreementTip: true,
            step: 1,
            username: '',
            usernameTip: null,
            IdCard: '',
            IdCardTip: null,
            scriptLoaded: false,
            showTipModal: false,
            getCodeMsg: "获取验证码",
        }
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    regCode = new RegExp(/^[0-9]{6}$/)

    componentDidMount() {
        const script = document.createElement("script");
        script.src = "//hm.baidu.com/hm.js?64f9bb47cd627a8a4069b1e07b127e1f";
        script.async = true;
        document.body.appendChild(script);
    }

    handleScriptError = () => {
        this.setShowTipModal('组件加载失败')
    }
    handleScriptLoad = () => {
        this.setState({
            scriptLoaded: true,
        });
    }
    setShowTipModal = (par) => {
        this.setState({
            showTipModal: !this.state.showTipModal,
            showTipText: par,
        })
    }
    checkPhone = () => {
        const {phone} = this.state;
        let phoneTip = 0;
        if (phone.length === 0) {
            phoneTip = 2;
        } else if (this.regPhone.test(phone)) {
            phoneTip = 1;
        } else {
            phoneTip = 3;
        }
        console.log("phoneTip=====" + phoneTip)
        this.setState({
            phoneTip: phoneTip,
        })

    };
    setPhone = (e) => {
        this.setState({phone: e, phoneTip: 0})
    }
    setCode = (e) => {
        let codeTip = 0;
        if (this.regCode.test(e)) {
            codeTip = 1
        }

        this.setState({
            code: e,
            codeTip: codeTip
        })
    }
    checkCode = () => {
        const {code} = this.state;
        let codeTip = 1;
        if (code.length === 0) {
            codeTip = 2
        }
        this.setState({
            codeTip: codeTip
        })

    };
    createDis = () => {
        var zm = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
        var zmd = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
        var x = "";
        var x1 = "";
        var i = 0;
        var j = 0;
        var n = 0;
        for (i = 0; i < 10; i++) {
            for (j = 8; j <= 16; j++) {
                for (n = 1; n <= j; n++) {
                    x += i;
                }
                x += ",";
            }
        }

        for (i = 0; i < zm.length; i++) {
            for (j = 8; j <= 16; j++) {
                var x3 = "";
                for (n = 1; n <= j; n++) {
                    x3 += zm[i];
                }
                x += x3;
                x += ",";
            }
        }
        for (i = 0; i < zmd.length; i++) {
            for (j = 8; j <= 16; j++) {
                var x4 = "";
                for (n = 1; n <= j; n++) {
                    x4 += zmd[i];
                }
                x += x4;
                x += ",";
            }
        }

        var x2 = ""
        for (i = 0; i <= 4; i++) {
            for (j = 6; j < 10; j++) {
                x1 = "";
                x2 = "";
                for (n = i; n <= j; n++) {
                    x1 = n + x1;
                    x2 += n;
                }
                x += x1
                x += ",";
                x += x2
                x += ",";
            }
        }
        return x.split(",");
    }
    setPassWord = (e) => {
        this.setState({
            password: e,
        })
    }
    checkPassWord = () => {
        const _that = this;
        const {password} = this.state;
        let passwordTip = '';
        if (_that.checkStrong(password) > 1 && this.checkPasswordSimple(password)) {
            passwordTip = 1;
        } else if (password.length === 0) {
            passwordTip = 2
        } else {
            passwordTip = 3
        }
        this.setState({
            passwordTip: passwordTip
        })

    };
    checkPasswordSimple = (txt) => {
        if (txt.length < 8) {
            return false;
        }
        let pwddis = this.createDis();
        for (let i = 0; i < pwddis.length - 1; i++) {
            if (txt === pwddis[i]) {
                return false;
            }
        }
        return true;
    }
    //checkStrong函数
    //返回密码的强度级别
    checkStrong = (sPW) => {
        if (sPW.length < 8)
            return 0; //密码太短
        let modes = 0;
        for (let i = 0; i < sPW.length; i++) {
            //测试每一个字符的类别并统计一共有多少种模式.
            modes |= this.CharMode(sPW.charCodeAt(i));
        }
        return this.bitTotal(modes)
    }
    CharMode = (iN) => {
        if (iN >= 48 && iN <= 57) //数字
            return 1;
        if (iN >= 65 && iN <= 90) //大写字母
            return 2;
        if (iN >= 97 && iN <= 122) //小写
            return 4;
        else
            return 8; //特殊字符
    }
    //bitTotal函数
    //计算出当前密码当中一共有多少种模式
    bitTotal = (num) => {
        let modes = 0;
        for (let i = 0; i < 4; i++) {
            if (num & 1) modes++;
            num >>>= 1;
        }
        return modes;
    }
    setAgreement = () => {
        const {agreementTip} = this.state;
        if (agreementTip) {
            this.setState({agreementTip: false});
        } else {
            this.setState({agreementTip: true});
        }
    }
    toNextStep = () => {
        const {
            phone,
            phoneTip,
            code,
            codeTip,
            password,
            passwordTip,
            step,
            agreementTip,
            username,
            usernameTip,
            IdCard,
            IdCardTip
        } = this.state;
        if (!agreementTip) {
            alert("请仔细阅读服务条款，并勾选服务条款");
            return;
        }
        if (step === 1) { //去注册
            if (phoneTip !== 1) {
                alert("请输入合法手机号");
                return;
            } else if (codeTip !== 1) {
                alert("请输入短信验证码");
                return;
            } else if (passwordTip !== 1) {
                alert("请选择合适长度的密码");
                return;
            }
            let params = {
                phonenumber: phone,
                checkcode: code,
                password: password,
                gender: 1
            }
            userRegister(params).then(ret => {
                if (ret.code === '10000') {
                    cookieUtil.putExpire('access_token', ret.data.accessToken);
                    this.setState({step: 2})
                } else {
                    alert(ret.msg);
                }
            }).catch(err => {
                console.log(err);
                alert("注册失败，请检查手机号跟短信验证码");
            });

        } else if (step === 2) {
            if (!cookieUtil.has('access_token')) {
                alert("请先去注册");
                return;
            }
            if (usernameTip !== 1) {
                alert("请输入真实姓名");
                return;
            } else if (IdCardTip !== 1) {
                alert("请输入合法身份证");
                return;
            }
            let params = {
                access_token: cookieUtil.get('access_token'),
                idCard: IdCard,
                realName: username,
                password: password
            }
            userRealAuth(params).then(ret => {
                if (ret.code === '10000') {
                    window.location.href = 'https://m.91y.com/login/';
                } else {
                    alert(ret.msg);
                }
            }).catch(err => {
                console.log(err);
                alert("实名认证异常");
            });
        }
    }
    setUserName = (e) => {
        this.setState({username: e})
    }
    checkUserName = () => {
        const {username} = this.state;
        let usernameTip = 1;
        if (username.length <= 1) {
            usernameTip = 2;
        }
        this.setState({
            usernameTip: usernameTip
        })

    };
    setIdCard = (e) => {
        this.setState({IdCard: e})
    }
    checkIdCard = () => {
        const {IdCard} = this.state;
        let IdCardTip = '';

        if (IdCard.length === 0) {
            IdCardTip = 2;
        } else if (!this.IsIdCard(IdCard)) {
            IdCardTip = 3;
        } else if (this.GetAge(IdCard) < 18) {
            IdCardTip = 4;
        } else {
            IdCardTip = 1;
        }
        this.setState({IdCardTip: IdCardTip})
    };
    IsIdCard = (number) => {
        let ret = this.checkRealIdcard(number);
        if (ret === 0) {
            return true;
        } else {
            return false;
        }
    };
    checkRealIdcard = (idcard) => {
        let area = {
            11: "北京",
            12: "天津",
            13: "河北",
            14: "山西",
            15: "内蒙古",
            21: "辽宁",
            22: "吉林",
            23: "黑龙江",
            31: "上海",
            32: "江苏",
            33: "浙江",
            34: "安徽",
            35: "福建",
            36: "江西",
            37: "山东",
            41: "河南",
            42: "湖北",
            43: "湖南",
            44: "广东",
            45: "广西",
            46: "海南",
            50: "重庆",
            51: "四川",
            52: "贵州",
            53: "云南",
            54: "西藏",
            61: "陕西",
            62: "甘肃",
            63: "青海",
            64: "宁夏",
            65: "新疆",
            71: "台湾",
            81: "香港",
            82: "澳门",
            91: "国外"
        }

        let Y, JYM;
        let S, M;
        let idcard_array = new Array();
        let ereg = '';
        //idcard = idcard.toUpperCase();
        idcard_array = idcard.split("");
        //地区检验
        if (area[parseInt(idcard.substr(0, 2))] == null) return 4;
        //身份号码位数及格式检验
        switch (idcard.length) {
            case 15:
                if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0 || ((parseInt(idcard.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0)) {
                    ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/; //测试出生日期的合法性
                } else {
                    ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/; //测试出生日期的合法性
                }
                if (ereg.test(idcard) && parseInt(idcard.substr(6, 2)) > 14) return 0;
                else return 2;
                break;
            case 18:
                //18位身份号码检测
                //出生日期的合法性检查
                //闰年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))
                //平年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))
                if (parseInt(idcard.substr(6, 4)) % 4 == 0 || (parseInt(idcard.substr(6, 4)) % 100 == 0 && parseInt(idcard.substr(6, 4)) % 4 == 0)) {
                    ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/; //闰年出生日期的合法性正则表达式
                } else {
                    ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/; //平年出生日期的合法性正则表达式
                }
                if (ereg.test(idcard)) {//测试出生日期的合法性
                    //计算校验位
                    S = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7
                        + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9
                        + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10
                        + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5
                        + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8
                        + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4
                        + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2
                        + parseInt(idcard_array[7]) * 1
                        + parseInt(idcard_array[8]) * 6
                        + parseInt(idcard_array[9]) * 3;
                    Y = S % 11;
                    M = "F";
                    JYM = "10X98765432";
                    M = JYM.substr(Y, 1); //判断校验位
                    if (M == idcard_array[17]) return 0; //检测ID的校验位
                    else return 3;
                } else return 2;
                break;
            default:
                return 1;
                break;
        }
    };
    GetAge = (identityCard) => {
        let len = (identityCard + "").length;
        if (len === 0) {
            return 0;
        } else {
            if ((len !== 15) && (len !== 18))//身份证号码只能为15位或18位其它不合法
            {
                return 0;
            }
        }
        let strBirthday = "";
        if (len === 18)//处理18位的身份证号码从号码中得到生日和性别代码
        {
            strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
        }
        if (len === 15) {
            strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
        }
        //时间字符串里，必须是“/”
        let birthDate = new Date(strBirthday);
        let nowDateTime = new Date();
        let age = nowDateTime.getFullYear() - birthDate.getFullYear();
        //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
        if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() === birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }
    showView = () => {
        const {phone, phoneTip, getCodeMsg} = this.state;
        console.log('getCodeMsg====' + getCodeMsg)
        if ("获取验证码" !== getCodeMsg) {
            return;
        }
        const _that = this;
        if (phoneTip !== 1) {
            return;
        } else {

            // eslint-disable-next-line
            let captcha1 = new TencentCaptcha(captchaRegAppId(), function (res) {

                console.log("res============" + JSON.stringify(res));
                // res（用户主动关闭验证码）= {ret: 2, ticket: null}
                // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
                if (res.ret === 0) {
                    // const urlParms = '?phone=' + phone + '&ticket=' + res.ticket + '&randstr=' + res.randstr + '&gameid=' + gameId + '&type=register';
                    const urlParms = {
                        'phone': phone,
                        'ticket': res.ticket,
                        'randStr': res.randstr,
                        'type': 'register'
                    }
                    AuthSendCode(urlParms).then(ret => {
                        if (ret.code === '10000') {
                            captcha1.destroy();
                            alert("验证码已发送，请注意查收")
                            let djs = 60;
                            let aa = '';
                            let timeout = setInterval(function () {
                                djs--;
                                aa = (djs === 0) ? '获取验证码' : (djs + 's');
                                if (djs === 0 || djs < 0) {
                                    clearInterval(timeout);
                                }
                                _that.setState({djs: djs, getCodeMsg: aa})
                            }, 999)
                        } else {
                            alert(ret.msg);
                            captcha1.destroy();
                        }
                    }).catch(err => {
                        console.log(err);
                        captcha1.destroy();
                    });
                }
            }, {bizState: 'RSCNO7XFNGG9r6xB'});
            captcha1.show(); // 显示验证码
        }
    }

    render() {
        const {
            phone,
            phoneTip,
            code,
            codeTip,
            password,
            passwordTip,
            agreementTip,
            step,
            username,
            usernameTip,
            IdCard,
            IdCardTip,
            getCodeMsg
        } = this.state;

        return (
            <IonPage>
                <meta name="viewport" content="width=750,target-densitydpi=device-dpi,user-scalable=no"/>
                <meta name="format-detection" content="telephone=no"/>
                <meta name="apple-mobile-web-app-capable" content="yes"/>
                <meta name="apple-mobile-web-app-status-bar-style" content="black"/>
                <IonContent fullscreen>
                    <Helmet placeholder={""}>
                        <link rel="stylesheet" href="//m.91y.com/templets/default/20190813/css/91y_phone.css"
                              type="text/css"/>
                        <link rel="stylesheet"
                              href="//m.91y.com//templets/default/20190813/css/91y_public.css?v=2021012801"
                              type="text/css"/>
                    </Helmet>
                    <div className="p-box">
                        <div className="login-box">
                            <div className="logo"></div>
                            {/*<--第一步-->*/}
                            <div className={step === 1 ? "content js-I" : "dn"}>
                                <ul>
                                    <li><IonInput type="text" className="ipt js-click"
                                                  maxlength={11} minlength={11} value={phone}
                                                  onIonChange={e => this.setPhone(e.detail.value)}
                                                  onIonBlur={e => this.checkPhone()}
                                                  placeholder="请输入11位手机号码"/>
                                        <div className={phoneTip > 1 ? "recharge-tip-new js-tip" : "dn"}>请输入11位手机号码
                                        </div>
                                    </li>
                                    <li>
                                        <Script
                                            url={captchaUrl()}
                                            onError={this.handleScriptError}
                                            onLoad={this.handleScriptLoad}
                                        />
                                        <IonInput type="text" className="ipt yzm js-click" style={{float: "left"}}
                                                  value={code} placeholder="请输入验证码" maxlength={6} minlength={4}
                                                  onIonChange={e => this.setCode(e.detail.value)}
                                                  onIonBlur={() => this.checkCode()}

                                        />
                                        <input type="button" id="smsSend" className="ipt-btn"
                                               onClick={() => this.showView()} value={getCodeMsg}/>
                                        <div
                                            className={codeTip > 1 ? "recharge-tip-new js-tip" : "dn"}>请输入短信验证码
                                        </div>
                                    </li>
                                    <li><IonInput type="password" className="ipt js-click" minlength={7} maxlength={17}
                                                  value={password} placeholder="请输入8-16位字符以上的密码"
                                                  onIonChange={e => this.setPassWord(e.detail.value)}
                                                  onIonBlur={() => this.checkPassWord()}/>
                                        <div
                                            className={passwordTip > 1 ? "recharge-tip-new js-tip" : "dn"}>请输入8-16个字符的字母、数字、特殊符号的组合
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {/*<--第一步end-->*/}
                            {/*<--第二步-->*/}
                            <div className={step === 2 ? "content js-II" : "dn"}>
                                <ul>
                                    <li>
                                        <IonInput type="text" className="ipt js-click"
                                                  value={username} placeholder="请输入真实姓名" maxlength={10}
                                                  minlength={2}
                                                  onIonChange={e => this.setUserName(e.detail.value)}
                                                  onIonBlur={() => this.checkUserName()}/>
                                        <div className={usernameTip > 1 ? "recharge-tip js-tip" : "dn"}>请输入真实姓名
                                        </div>
                                    </li>

                                    <li>
                                        <IonInput type="text" className="ipt js-click" value={IdCard}
                                                  placeholder="请输入身份证号" maxlength={18} minlength={10}
                                                  onIonChange={e => this.setIdCard(e.detail.value)}
                                                  onIonBlur={() => this.checkIdCard()}/>
                                        <div className={IdCardTip > 1 ? "recharge-tip js-tip" : "dn"}>请输入身份证号
                                        </div>

                                    </li>
                                </ul>
                            </div>
                            {/*<--第二步end-->*/}
                            <a onClick={() => this.toNextStep()} className={step === 1 ? "login-btn" : "dn"}>下一步</a>
                            <a className={step === 2 ? "login-btn" : "dn"} onClick={() => this.toNextStep()}>提交</a>
                            <div className="agreement">
                                <p><span className={agreementTip ? 'selected' : 'uncheck'}
                                         onClick={() => this.setAgreement()}></span>我已阅读并接受<a
                                    href="https://wfw.fuyuncc.com/service.html">《用户协议》</a><a
                                    href="https://wfw.fuyuncc.com/privacy.html">《个人信息保护政策》</a></p>
                            </div>
                        </div>

                        {/*<!------------版权----------------->*/}
                        <MFooter title={""} isJumpLogin={false}/>
                    </div>
                </IonContent>
            </IonPage>
        );
    }
}

export default withRouter(PhoneRegister);
